import { useQuery } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { errorHandler } from '@app/utils/errorHandler';
import { TeamYearlyPlanResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  year?: number;
};

const getManagersYearlyPlanList = async (params: Params): Promise<TeamYearlyPlanResponse> => {
  const { data } = await api.get<TeamYearlyPlanResponse>(
    `${BI_BASE_URL}/managers/year_team_plan/list`,
    { params }
  );

  return data;
};

export const useGetManagersYearlyPlanList = (year?: number) => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.MANAGERS_YEARLY_PLAN_LIST, year],
    queryFn: () => getManagersYearlyPlanList({ year }),
    ...errorHandler,
  });
};
